import React, { Component } from 'react';
import './atable.scss';

export default class ATable extends Component {

    render() {
        const {className, children, ...otherProps} = this.props;
        return (
            <table className={`atable ${className ? className : ''}`} {...otherProps}>
                {children}
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/views/aTable/ATable.js